import React, { useState } from 'react'
import { RegionManager } from '@/shared/ui'
import { 
  useRegions, 
  useCreateRegion, 
  useUpdateRegion, 
  useDeleteRegion 
} from '@/shared/hooks'
import type { RegionCreateRequest, RegionUpdateRequest } from '@/shared/api'

export const RegionsPage: React.FC = () => {
  const { data, isLoading, error } = useRegions(false)
  const createRegion = useCreateRegion()
  const updateRegion = useUpdateRegion()
  const deleteRegion = useDeleteRegion()

  const handleCreate = (data: RegionCreateRequest) => {
    createRegion.mutate(data)
  }

  const handleUpdate = (id: number, data: RegionUpdateRequest) => {
    updateRegion.mutate({ id, request: data })
  }

  const handleDelete = (id: number) => {
    deleteRegion.mutate(id)
  }

  return (
    <RegionManager
      title="Регионы"
      description="Управление справочником регионов"
      data={data || []}
      loading={isLoading}
      error={error}
      includeInactive={false}
      onToggleInactive={undefined}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      isCreating={createRegion.isPending}
      isUpdating={updateRegion.isPending}
      isDeleting={deleteRegion.isPending}
    />
  )
}
